module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-module mb"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "focus-warp"
  }, [_c('div', {
    staticClass: "swipe-wrap",
    attrs: {
      "id": "qua-swiper"
    }
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.list), function(ch) {
    return _c('CarouselItem', {
      key: ch.aid
    }, _vm._l((ch), function(item, index) {
      return _c('div', {
        key: item.aid,
        staticClass: "qua-item"
      }, [_c('router-link', {
        attrs: {
          "to": item.url,
          "target": "_blank"
        }
      }, [_c('img', {
        staticClass: "img-item",
        attrs: {
          "src": item.atturl,
          "alt": item.aname
        }
      })])], 1)
    }), 0)
  }), 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "module-title"
  }, [_c('span', [_vm._v("精品速递")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-109a3cc5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/enterprise-brand-store/boutique.vue
// module id = 1529
// module chunks = 1